import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

export const actions = mapActions([
    'LOG_USER_FEEDBACK',
    'LOG_USER_FEEDBACK_SUCCESS',
    'SHOULD_PROMPT_USER_FEEDBACK',
    'PROMPT_USER_FEEDBACK',
    'SHOW_FEEDBACK_MODAL',
    'HIDE_FEEDBACK_MODAL',
    'SET_CHECKED_FOR_PROMPT'
], 'FEEDBACK');

export const logUserFeedback = createFormAction(actions.LOG_USER_FEEDBACK);
export const logUserFeedbackSuccess = createAction(actions.LOG_USER_FEEDBACK_SUCCESS);
export const shouldPromptUserFeedback = createAction(actions.SHOULD_PROMPT_USER_FEEDBACK);
export const promptUserFeedback = createAction(actions.PROMPT_USER_FEEDBACK);
export const showFeedbackModal = createAction(actions.SHOW_FEEDBACK_MODAL);
export const hideFeedbackModal = createAction(actions.HIDE_FEEDBACK_MODAL);
export const setHasCheckedForFeedbackPrompt = createAction(actions.SET_CHECKED_FOR_PROMPT);

const initialState = {
    feedbackModal: false,
    promptFeedback: false,
    feedbackPromptId: null,
    hasCheckedForFeedbackPrompt: false
};

export default handleActions({
    [actions.LOG_USER_FEEDBACK_SUCCESS]: state => update(state, { $set: initialState }),
    [actions.PROMPT_USER_FEEDBACK]: (state, action) => update(state, {
        feedbackModal: { $set: true },
        feedbackPromptId: { $set: action.payload.feedbackPromptId },
        promptFeedback: { $set: action.payload.promptFeedback }
    }),
    [actions.SHOW_FEEDBACK_MODAL]: state => update(state, { feedbackModal: { $set: true } }),
    [actions.HIDE_FEEDBACK_MODAL]: state => update(state, {
        feedbackModal: { $set: false },
        feedbackPromptId: { $set: null }
    }),
    [actions.SET_CHECKED_FOR_PROMPT]: state => update(state, { hasCheckedForFeedbackPrompt: { $set: true } })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/feedback/duck.js